import { DEFAULT_LANGUAGE } from './config';
/**
 * Le o idioma do dispositivo/browser de forma segura.
 *
 * Fica isolado aqui para que `navigator.language` nunca seja acessado
 * diretamente pelos componentes. Retorna string vazia quando `navigator`
 * nao existe (ex.: ambientes sem DOM), delegando o fallback a
 * getBrowserLanguage().
 */
function readNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
        return '';
    }
    return navigator.language || '';
}
/**
 * Le o fuso horario resolvido pelo dispositivo (ex.: 'America/Sao_Paulo').
 *
 * E o sinal mais confiavel de LOCALIZACAO do usuario disponivel localmente,
 * sem depender do servidor. Retorna string vazia se a API Intl nao existir.
 */
function readTimeZone() {
    try {
        if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
            return '';
        }
        return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    }
    catch (_a) {
        return '';
    }
}
/**
 * Fusos horarios do Brasil (IANA). Lista explicita para evitar falsos
 * positivos com outros paises da regiao 'America/*'.
 */
var BRAZIL_TIME_ZONES = [
    'America/Sao_Paulo',
    'America/Bahia',
    'America/Fortaleza',
    'America/Recife',
    'America/Belem',
    'America/Maceio',
    'America/Araguaina',
    'America/Manaus',
    'America/Cuiaba',
    'America/Campo_Grande',
    'America/Porto_Velho',
    'America/Boa_Vista',
    'America/Rio_Branco',
    'America/Santarem',
    'America/Eirunepe',
    'America/Noronha',
];
/** Indica se o fuso informado pertence ao Brasil. Funcao pura, testavel. */
export function isBrazilTimeZone(timeZone) {
    if (timeZone === void 0) { timeZone = readTimeZone(); }
    if (!timeZone) {
        return false;
    }
    // indexOf (em vez de Array.prototype.includes) por compatibilidade com ES5.
    return BRAZIL_TIME_ZONES.indexOf(timeZone) !== -1;
}
/**
 * Resolve o idioma da aplicacao a partir da LOCALIZACAO do usuario.
 *
 * Regra do produto:
 * - Usuario no Brasil    => 'pt-BR'
 * - Qualquer outro lugar => 'en' (ingles, sempre)
 *
 * Como decidimos "esta no Brasil?", usando apenas sinais locais:
 * - fuso horario do dispositivo pertencente ao Brasil (sinal de localizacao), OU
 * - idioma do dispositivo em Portugues do Brasil ('pt-BR'), como reforco para
 *   quando o fuso estiver indisponivel ou atipico.
 *
 * Basta um dos sinais indicar Brasil. Qualquer outra combinacao cai em ingles
 * (inclusive pt-PT, es-*, etc.).
 *
 * Funcao pura: aceita os sinais como argumentos para facilitar os testes.
 *
 * @param language Codigo BCP-47. Default: navigator.language.
 * @param timeZone Fuso IANA. Default: Intl.DateTimeFormat().resolvedOptions().timeZone.
 */
export function getBrowserLanguage(language, timeZone) {
    if (language === void 0) { language = readNavigatorLanguage(); }
    if (timeZone === void 0) { timeZone = readTimeZone(); }
    var normalized = (language || '').trim().toLowerCase();
    var languageIndicatesBrazil = normalized === 'pt-br';
    var locationIsBrazil = isBrazilTimeZone(timeZone);
    if (locationIsBrazil || languageIndicatesBrazil) {
        return 'pt-BR';
    }
    return DEFAULT_LANGUAGE;
}
